import {
  LANDING_FAQ_PL,
  PRODUCT_DEFINITION_PL,
  SITE_URL,
} from './aeoContent'
import { SITE_NAME } from './site'

export function buildLandingJsonLdGraph(origin: string) {
  const base = origin || SITE_URL
  const home = `${base.replace(/\/$/, '')}/`

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${home}#website`,
        name: SITE_NAME,
        url: home,
        description: PRODUCT_DEFINITION_PL,
        inLanguage: ['pl', 'en'],
      },
      {
        '@type': 'Organization',
        '@id': `${home}#organization`,
        name: 'Miejsca Dolnego Śląska',
        url: home,
        sameAs: [
          'https://www.facebook.com/miejscadolnegoslaska/',
          'https://www.instagram.com/miejsca.dolnegoslaska/',
          'https://www.tiktok.com/@miejscadolnegoslaska',
        ],
      },
      {
        '@type': 'Product',
        '@id': `${home}#product`,
        name: 'Paszport Dolnego Śląska 2026',
        description: PRODUCT_DEFINITION_PL,
        brand: { '@type': 'Brand', name: SITE_NAME },
        offers: {
          '@type': 'Offer',
          price: '19',
          priceCurrency: 'PLN',
          availability: 'https://schema.org/InStock',
          url: `${base.replace(/\/$/, '')}/formularz`,
        },
        category: 'Regional tourism program',
      },
      {
        '@type': 'TouristTrip',
        '@id': `${home}#trip`,
        name: 'Paszport Dolnego Śląska — 12 miejsc w 12 miesięcy',
        description: PRODUCT_DEFINITION_PL,
        touristType: 'Cultural tourism',
        itinerary: {
          '@type': 'ItemList',
          numberOfItems: 12,
          description: '12 curated places across Lower Silesia, Poland',
        },
      },
      {
        '@type': 'FAQPage',
        '@id': `${home}#faq`,
        mainEntity: LANDING_FAQ_PL.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      },
    ],
  }
}

export function buildFaqJsonLd(faq: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  }
}
